export default "__VITE_ASSET__e8ea48c0__"